// 获取钱包接口
import { useState, useEffect } from "react";
import { getPermissionApi } from "@/api/organization";
import { useOrganization } from "@clerk/clerk-react";
import { message } from "antd";
import {
  getStoredLanguageOrNull,
  getInitialLanguage,
  DEFAULT_LANGUAGE,
  SupportedLanguage,
} from "@/i18n";

const useUserPermission = () => {
  const { organization } = useOrganization();
  const [isHasTodoList, setTodoList] = useState(null);
  const [isAdmin, setAdmin] = useState(false);
  const [canSetMaxCpm, setCanSetMaxCpm] = useState(false);
  const [language, setLanguage] = useState<SupportedLanguage | null>(
    getInitialLanguage()
  );
  const [isLanguageLoaded, setIsLanguageLoaded] = useState(false);
  const [canSetInvitesSendingMode, setCanSetInvitesSendingMode] =
    useState(false);

  useEffect(() => {
    if (!organization?.id) {
      return;
    }

    const fetchData = async () => {
      try {
        const { data } = await getPermissionApi();
        setTodoList(
          data?.isAdmin || data?.isAdsMaster || data?.orgHasAdsMaster
        );
        setAdmin(data?.isAdmin);
        setCanSetMaxCpm(data?.canSetMaxCpm);
        setCanSetInvitesSendingMode(data?.canSetInvitesSendingMode || false);
        // 处理从 API 返回的语言代码，确保格式正确
        const apiLanguage = data?.language;
        let finalLanguage: SupportedLanguage;

        if (apiLanguage) {
          // 如果 API 返回的是旧格式，转换为新格式
          if (apiLanguage === "zh" || apiLanguage === "zh-CN") {
            finalLanguage = "zh-CN";
          } else if (apiLanguage === "en" || apiLanguage === "en-US") {
            finalLanguage = "en-US";
          } else {
            // 如果是不支持的语言，使用默认语言
            finalLanguage = DEFAULT_LANGUAGE;
          }
        } else {
          // 如果 API 没有返回语言，使用存储的语言或默认语言
          finalLanguage = getStoredLanguageOrNull() || getInitialLanguage();
        }

        setLanguage(finalLanguage);
        setIsLanguageLoaded(true);
      } catch (err: any) {
        // message.error(`${err}`);
        setIsLanguageLoaded(true);
      }
    };
    fetchData();
  }, []);

  // 提供一个更新语言的函数
  const updateLanguage = (newLanguage: SupportedLanguage) => {
    setLanguage(newLanguage);
  };

  return {
    isHasTodoList,
    isAdmin,
    canSetMaxCpm,
    language,
    updateLanguage,
    isLanguageLoaded,
    canSetInvitesSendingMode,
  };
};

export default useUserPermission;
